var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "downloadContainer", staticClass: "download-container" },
    [
      _c(
        "v-btn",
        {
          staticClass: "open-download-btn",
          staticStyle: { float: "right", "margin-top": "0" },
          attrs: { small: "", icon: "", title: _vm.$t("download.download") },
          on: {
            click: function($event) {
              return _vm.openDownload()
            }
          }
        },
        [_c("v-icon", [_vm._v("cloud_download")])],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "600", attach: "body", persistent: true },
          model: {
            value: _vm.isDownloadModalOpen,
            callback: function($$v) {
              _vm.isDownloadModalOpen = $$v
            },
            expression: "isDownloadModalOpen"
          }
        },
        [
          _c(
            "box",
            {
              attrs: {
                customClass: "download-modal",
                background: "white",
                closable: ""
              },
              on: {
                closed: function($event) {
                  return _vm.closeDownload()
                }
              },
              model: {
                value: _vm.isDownloadModalOpen,
                callback: function($$v) {
                  _vm.isDownloadModalOpen = $$v
                },
                expression: "isDownloadModalOpen"
              }
            },
            [
              _c("h3", { attrs: { slot: "header" }, slot: "header" }, [
                _vm._v(_vm._s(_vm.$t("download.downloadRoute")))
              ]),
              _vm._v(" "),
              _c("v-text-field", {
                staticClass: "export-file-name",
                attrs: {
                  label: _vm.$t("download.downloadFileName"),
                  required: true
                },
                model: {
                  value: _vm.downloadFileName,
                  callback: function($$v) {
                    _vm.downloadFileName = $$v
                  },
                  expression: "downloadFileName"
                }
              }),
              _vm._v(" "),
              _c("v-select", {
                staticClass: "download-format",
                attrs: {
                  label: _vm.$t("download.downloadFormat"),
                  items: _vm.availableDownloadFormats
                },
                model: {
                  value: _vm.downloadFormat,
                  callback: function($$v) {
                    _vm.downloadFormat = $$v
                  },
                  expression: "downloadFormat"
                }
              }),
              _vm._v(" "),
              _c(
                "v-layout",
                { attrs: { row: "", wrap: "" } },
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm6: "" } },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "download",
                          staticStyle: { float: "right", "margin-top": "0" },
                          attrs: {
                            color: "primary",
                            title: _vm.$t("download.download")
                          },
                          on: {
                            click: function($event) {
                              return _vm.download()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("download.download")))]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7f766afb", { render: render, staticRenderFns: staticRenderFns })
  }
}